module.exports = __webpack_public_path__ + "img/coffee_bean1.7448a016.png";